import {Command} from "./Command";
import {SetPlayResultCommand} from "./SetPlayResultCommand";
import {SetYardLineCommand} from "./SetYardLineCommand";
import {SetDistanceCommand} from "./SetDistanceCommand";
import {DEFAULT_FIRST_DOWN_DISTANCE, DEFAULT_YARD_LINE} from "../helpers/distance";
import {SetDownCommand} from "./SetDownCommand";
import {Down} from "../model/down";
import {SetScoringPlayCommand} from "./SetScoringPlayCommand";
import {PlayResult} from "../model/playResult";
import {GameService} from "../services/game.service";
import { HttpClient } from "@angular/common/http";

export class SetSimpleCommand implements Command {
  private commands: Command[] = [];

  constructor(
    private game: GameService,
    public result: PlayResult,
    private http: HttpClient
  ) { }

  execute() {
    console.log('COMMAND SetSimpleCommand')
    this.commands.push(
      new SetPlayResultCommand(this.game.getFirstPendingGamePlay(), this.result),
      new SetScoringPlayCommand(this.game.getFirstPendingGamePlay(),this.game.game, this.result, this.http, this.game)
    )
    for (const command of this.commands) {
      command.execute();
    }

    this.game.addCommandsAfterTagging([
      new SetDistanceCommand(this.game.getNextGamePlay(), DEFAULT_FIRST_DOWN_DISTANCE),
      new SetDownCommand(this.game.getNextGamePlay(), Down.D1),
      new SetYardLineCommand(this.game.getNextGamePlay(), DEFAULT_YARD_LINE)
    ])
  }
}
